// @core/api/endpoints/team/remove_team_permission_from_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/team';

/**
 * Remove permissions from role
 * Removes one or more permissions from a role. All members with this role lose the removed capabilities immediately.
 */
export async function RemoveTeamPermissionFromRole(
  team_id: string,
  role_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/roles/:role_id/permissions`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':role_id', encodeURIComponent(role_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
